import React from 'react';
import Modal from '../../../../components/Modal/Modal';
import Tabs from '../../../../components/Tabs/Tabs';
import TabPanel from '../../../../components/TabPanel/TabPanel';
import Phase0Tab from './Phase0Tab';
import Phase1Tab from './Phase1Tab';
import Phase2Tab from './Phase2Tab';
import Phase3Tab from './Phase3Tab';
import OverviewTab from './OverviewTab';
import { getVisibleTabs } from './utils';
import './PlayerGuessesModal.css';

const PlayerGuessesModal = ({ isOpen, onClose, player, phaseLocks = {}, realResults = {} }) => {
  // Opret en liste over tabs der skal vises baseret på phaseLocks
  const visibleTabs = getVisibleTabs(phaseLocks);

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={player?.name ? `${player.name}` : 'Spiller Gæt'}
      size="large"
    >
      {!player || !player.name ? (
        <div className="player-guesses">
          <p className="no-guess">Ingen spiller data tilgængelig</p>
        </div>
      ) : (
        <div className="player-guesses">
          <div className="total-points-header">
            <h3>Total Points: <span className="points-highlight">{player.points || 0}</span></h3>
          </div>

          <Tabs defaultActiveTab={0} className="player-guesses-tabs">
          {visibleTabs.map(tab => {
            if (tab.phase === 0) {
              return (
                <TabPanel key={tab.id} label={tab.label} tabId={tab.id}>
                  <Phase0Tab player={player} />
                </TabPanel>
              );
            }

            if (tab.phase === 1) {
              return (
                <TabPanel key={tab.id} label={tab.label} tabId={tab.id}>
                  <Phase1Tab player={player} realResults={realResults} />
                </TabPanel>
              );
            }

            if (tab.phase === 2) {
              return (
                <TabPanel key={tab.id} label={tab.label} tabId={tab.id}>
                  <Phase2Tab player={player} phaseLocks={phaseLocks} realResults={realResults} />
                </TabPanel>
              );
            }

            if (tab.phase === 3) {
              return (
                <TabPanel key={tab.id} label={tab.label} tabId={tab.id}>
                  <Phase3Tab player={player} />
                </TabPanel>
              );
            }

            if (tab.phase === 4) {
              return (
                <TabPanel key={tab.id} label={tab.label} tabId={tab.id}>
                  <OverviewTab player={player} phaseLocks={phaseLocks} />
                </TabPanel>
              );
            }

            return <></>;
          })}
        </Tabs>
        </div>
      )}
    </Modal>
  );
};

export default PlayerGuessesModal;

